"use client";
import { useCallback, useEffect, useState } from "react";
import { SearchBoxV2 } from "@/components/SearchBoxV2";
import { useRouter, usePathname } from "next/navigation";
import { Plus } from '@phosphor-icons/react/dist/ssr'

const AddToCompare = () => {
  const [showSearch, setShowSearch] = useState(false);
  const router = useRouter();
  const path = usePathname();
  const onProjectSelect = useCallback(
    (params: {
      text?: string;
      projectName?: string;
      projectId?: string;
      villageName?: string;
      villageId?: number;
    }) => {
      const { projectId } = params;
      if (projectId) {
        console.log("Attempting navigation to /", projectId);
        setTimeout(() => {
          console.log("Forcing navigation with window.location");
          if (path === "/compare") {
            router.push(`/compare/${projectId}`);
          } else {
            router.push(`${path},${projectId}`);
          }
        }, 10);
      }
    },
    [router]
  );

  useEffect(() => {
    console.log("Component mounted, router:", router);
    console.log("Current pathname:", path);
  }, [router, path]);
  return (
    <div className="min-w-60 flex justify-center">
      {!showSearch ? (
          <button
            className="btn btn-secondary"
            onClick={() => setShowSearch(true)}
            >
            <Plus weight="bold" size={16}/>
            Add to Compare
          </button>
      ) : (
        <SearchBoxV2
          placeHolderText={["Search for a project to compare..."]}
          onTextChange={onProjectSelect}
          useLinksForResults={false}
          resultTypes="projects"
        />
      )}
    </div>
  );
};

export default AddToCompare;
